<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="approval_hierarchy_array_list"
        class="elevation-1 mytable"
        dense
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title
              >Transport Approval Hierarchy Master</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small
                  >Add Transport Approval Hierarchy</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-select
                            dense
                            v-model="editedItem.apporval_authority"
                            :items="transport_apporval_authority_array_list"
                            item-text="name"
                            item-value="id"
                            label="Transport Approval Authority"
                            persistent-hint
                            hint="Transport,School-Accountant..."
                            :disabled="editedIndex != -1"
                            return-object
                            single-line
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.level"
                            persistent-hint
                            label="Approval Hierarchy Level"
                            :rules="[(v) => !!v || 'required']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox
                            dense
                            v-model="editedItem.islastlevel"
                            color="success"
                            label="Is Last Level in Approval Hierarchy?"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="mb-2 button"
                      color="primary"
                      @click="save"
                      :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.islastlevel="{ item }">
          <v-switch
            inset
            v-model="item.islastlevel"
            :color="item.islastlevel ? 'success' : 'primary'"
            @change="islastlevel_toggle(item)"
          ></v-switch>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch
            inset
            v-model="item.isactive"
            :color="item.isactive ? 'success' : 'primary'"
            @change="isactive_toggle(item)"
          ></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      level: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Transport Approval Authority Name",
        align: "left",
        sortable: false,
        value: "transportapporvalauthority",
      },
      {
        text: "Level",
        align: "left",
        sortable: true,
        value: "level",
      },
      {
        text: "Is Last Level",
        align: "left",
        sortable: true,
        value: "islastlevel",
      },

      {
        text: "Is Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    approval_hierarchy_array_list: [],
    transport_apporval_authority_array_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      level: "",
      apporval_authority: "",
      isactive: true,
      islastlevel: true,
    },
    defaultItem: {
      id: "",
      level: "",
      apporval_authority: "",
      isactive: true,
      islastlevel: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Transport Approval Hierarchy"
        : "Edit Transport Approval Hierarchy";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.approval_hierarchy_array_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Transport/transportApprovalHierarchy")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.approval_hierarchy_array_list =
              res.data.approval_hierarchy_array_list;
            this.transport_apporval_authority_array_list =
              res.data.transport_apporval_authority_array_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // if (this.isValidated()) {
        axios
          .post("/Transport/editTransportApprovalHierarchy", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //window.alert(res.data.msg)
              this.showSnackbar(
                "#4caf50",
                "Transport Approval Hierarchy Updated Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
        // }
      } else {
        axios
          .post("/Transport/saveTransportApprovalHierarchy", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.approval_hierarchy_array_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Transport Approval Hierarchy Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.code == "NA") {
              //window.alert(res.data.status.code)
              //alert(res.data.status.message)
              this.showSnackbar(
                "#b71c1c",
                "Transport Approval Hierarchy Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()

    islastlevel_toggle(item) {
      const data = {
        id: item.id,
        toggle: item.islastlevel,
      };
      this.overlay = true;
      axios
        .post("/Transport/isLastLevelInHierarchyToggle", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar(
              "#4caf50",
              "Transport Approval Hierarchy Status Changed!"
            ); // show snackbar
            this.onLoad();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    isactive_toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Transport/isactiveTransportApprovalHierarchy", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar(
              "#4caf50",
              "Transport Approval Hierarchy Status Changed!"
            ); // show snackbar
            this.onLoad();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>